import React from "react";
import { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import image from "../../logos/resolution.png";
import "../../components/CommonDashboard.css";
import { setCurrentEmms } from "../../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../../redux/slices/emmsAuthSlice";
import EventCustomisationTable from "./EventCustomisationTable";
import Login from "../Login";
import TitleWithDropdown from "../TitleWithDropdown";
import MyEventCustomisationForm from "./MyEventCustomisationForm";
import PlaylistTable from "./PlaylistTable";
import MyPlaylistForm from "./MyPlaylistForm";
import { setPlaylist } from "../../redux/slices/playlistSlice";
import { setResolutionsList } from "../../redux/slices/resolutionSlice";
import MyResolutionForm from "./MyResolutionForm";
import ResolutionTable from "./ResolutionTable";

function ResolutionDashboard({ selected }) {
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);

  const [responseData, setResponseData] = useState(null);
  const headers = useSelector((state) => state.header);

  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);

  function fetchData(selectedOption) {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find(
      (element) => element.id === selectedOption
    );

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "resolution",
        query: {},
        emmsId: selectedOption,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setResponseData(response.data);
          dispatch(setResolutionsList(response.data));
          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  useEffect(() => {
    fetchData(selectedOption);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    fetchData(event.target.value);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
      <div className="mainContainer emms-main-container ">
        <header className="emms-main-container-left-align"  style={{ marginLeft: "10%" }}>
          <figure className="emms-image-figure" >
            <img  className="img emm-image content-ai-header-image" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div>
            <MyResolutionForm selectedOption={selectedOption} />
          </div>
        </div>
        <div className="emms-main-container-left-align"  style={{ marginLeft: "10%" }}>
          <ResolutionTable selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
}

export default ResolutionDashboard;
